var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNightDay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2445 4244 c-702 -109 -1254 -623 -1411 -1314 -101 -446 -11 -933 244 -1313 272 -407 693 -670 1186 -743 147 -22 416 -14 561 15 425 87 802 330 1049 675 32 44 56 89 56 103 0 14 -13 37 -29 54 l-29 29 -129 0 c-351 0 -662 122 -916 360 -212 198 -358 474 -403 760 -20 125 -15 364 10 475 58 260 177 477 372 676 58 60 94 104 94 117 0 32 -20 69 -44 81 -72 38 -434 53 -611 25z m375 -160 c0 -3 -20 -30 -44 -60 -145 -178 -247 -387 -303 -624 -37 -157 -43 -400 -14 -569 54 -318 191 -582 421 -811 251 -252 534 -388 895 -433 l100 -12 -96 -95 c-210 -209 -462 -348 -754 -416 -112 -26 -135 -28 -330 -28 -179 0 -224 3 -307 21 -332 75 -631 248 -840 488 -617 707 -476 1772 302 2292 189 127 430 216 665 246 49 6 305 7 305 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightDay);
export default __webpack_public_path__ + "static/media/NightDay.e9a797bdfe4b1e22141405a20c4e7958.svg";
export { ForwardRef as ReactComponent };